export default __webpack_public_path__ + "5f63cb7f47b6ea89773b43a6e687e5a5.woff";